import { render, staticRenderFns } from "./SidebarSorting.vue?vue&type=template&id=41a0480e&scoped=true"
import script from "./SidebarSorting.vue?vue&type=script&lang=js"
export * from "./SidebarSorting.vue?vue&type=script&lang=js"
import style0 from "./SidebarSorting.vue?vue&type=style&index=0&id=41a0480e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0480e",
  null
  
)

export default component.exports